import React, { Component } from 'react'
import { Form, Checkbox } from 'antd';

export class VatFee extends Component {
  state = {
    vat_toll_fee: 0,
  }

  onChange = vat_toll_fee => {
    this.setState({
      vat_toll_fee
    });
  };

  render() {
    const { vat_toll_fee } = this.state;
    const { isEdit, isOwner, typeOption } = this.props;
    return <>
      <div className="title-contract title-special">9. Tính VAT*</div>
      <Form.Item wrapperCol={24} label="">
        <div className="vat-fee">
          <Checkbox className={(!isOwner && typeOption !== 'create_new') ? 'hidePrice' : ''} disabled={!isEdit || (typeOption !== 'create_new' && !isOwner)} onChange={() =>this.onChange(1)} checked={vat_toll_fee === 1}>Giá trước toll fee</Checkbox>
          <Checkbox className={(!isOwner && typeOption !== 'create_new') ? 'hidePrice' : ''} disabled={!isEdit || (typeOption !== 'create_new' && !isOwner)} onChange={() =>this.onChange(0)} checked={vat_toll_fee === 0}>Giá sau toll fee</Checkbox>  
        </div>
      </Form.Item>
        
    </>
  }
}
